import { IsIn, IsOptional, IsString, MaxLength, MinLength } from 'class-validator';
import { ServiceRequestCategory, ServiceRequestPriority, ServiceRequestStatus } from '@chat/prisma-client';

const STATUSES: ServiceRequestStatus[] = ['open', 'assigned', 'in_progress', 'in_review', 'closed', 'reopened'];
const PRIORITIES: ServiceRequestPriority[] = ['low', 'medium', 'high', 'critical'];
const CATEGORIES: ServiceRequestCategory[] = ['order', 'delivery', 'payment', 'general'];

export class UpdateServiceRequestStatusDto {
  @IsIn(STATUSES)
  status!: ServiceRequestStatus;
}

export class AssignServiceRequestDto {
  // Omitted = "assign to me" — the controller fills these in from the
  // authenticated agent's own identity when absent.
  @IsOptional()
  @IsString()
  agentId?: string;

  @IsOptional()
  @IsString()
  agentName?: string;
}

export class TransferServiceRequestDto {
  @IsString()
  @MinLength(1)
  agentId!: string;

  @IsString()
  @MinLength(1)
  agentName!: string;
}

export class AddServiceRequestNoteDto {
  @IsString()
  @MinLength(1)
  @MaxLength(4000)
  content!: string;
}

export class ListServiceRequestsQueryDto {
  @IsOptional()
  @IsIn(['mine', 'open', 'all'])
  scope: 'mine' | 'open' | 'all' = 'all';

  @IsOptional()
  @IsIn(STATUSES)
  status?: ServiceRequestStatus;

  @IsOptional()
  @IsIn(PRIORITIES)
  priority?: ServiceRequestPriority;

  @IsOptional()
  @IsIn(CATEGORIES)
  category?: ServiceRequestCategory;

  @IsOptional()
  @IsString()
  @MaxLength(255)
  search?: string;
}
